import styled from 'styled-components/macro';

export const Wrapper = styled.div`
    height: 100%;
    width: 100%;
    padding: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
